export const BASE_URL = "https://api.spacexdata.com/v4";